module.exports = __webpack_public_path__ + "static/img/run.adab9423.svg";